<template>
  <div class="home" v-loading="loading">
    <div class="swiper-slide">
      <div class="page" v-if="language == 'ZH'">
        <h3 style="text-align: justify;">{{ $t('h.GrowthProcess') }}</h3>
        <p>
          <span>2004年</span> 深圳总部
        </p>
        <p>
          <span>2007年</span> 北京公司
        </p>
        <p>
          <span>2009年</span> 上海公司
        </p>
        <p>
          <span>2012年</span> 广州公司
        </p>
        <p>
          <span>2012年</span> 海南公司
        </p>
        <p>
          <span>2018年</span> 云南公司
        </p>
        <p>
          <span>2019年</span> 重庆 成都 贵阳 长沙 武汉 青岛
        </p>
      </div>
      <div class="page" v-else>
        <h3 style="letter-spacing: 0;">{{ $t('h.GrowthProcess') }}</h3>
        <p style="letter-spacing: 0;">
          <span>2004</span> Shenzhen headquarters
        </p>
        <p style="letter-spacing: 0;">
          <span>2007</span> Beijing branch
        </p>
        <p style="letter-spacing: 0;">
          <span>2009</span> Shanghai branch
        </p>
        <p style="letter-spacing: 0;">
          <span>2012</span> Guangzhou branch
        </p>
        <p style="letter-spacing: 0;">
          <span>2012</span> Hainan office
        </p>
        <p style="letter-spacing: 0;">
          <span>2018</span> Yunnan office
        </p>
        <p style="letter-spacing: 0;">
          <span>2019</span> Chongqing office&nbsp;Chengdu office&nbsp;Guiyang office&nbsp;Changsha office&nbsp;Wuhan office&nbsp;Qingdao office
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "HelloWorld",
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      loading: true,
      caseList: [],
      newsList: [],
      swiperOption: {
        notNextTick: true,
        direction: "vertical",
        grabCursor: true,
        setWrapperSize: true,
        autoHeight: true,
        slidesPerView: 1,
        mousewheel: true,
        mousewheelControl: true,
        height: window.innerHeight - 115,
        resistanceRatio: 0,
        observeParents: true,
        on: {},
      },
      language: localStorage.getItem("lang") || "ZH"
    };
  },
  created() { },
  mounted() {
    this.loading = false;
  },
};
</script>

<style scoped>
.swiper-slide {
  font-size: 1.2rem;
  margin-top: 10rem;

}

.page {
  width: 100%;
  margin-top: -7.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

h3 {
  font-size: 2.5rem;
  letter-spacing: 2rem;
  margin-left: 10px;
}

p {
  font-size: 1.5rem;
  letter-spacing: 0.75rem;
  margin-top: 1.5rem;
}

span {
  letter-spacing: 5px;
}

.slide-one {
  position: relative;
}
</style>